import React from 'react';
import { cn } from '../../utils/cn';

const Input = React.forwardRef(({
  className,
  type = 'text',
  placeholder,
  value,
  onChange,
  error,
  disabled = false,
  required = false,
  ...props
}, ref) => {
  const baseClasses = 'flex h-10 w-full rounded-xl border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm';
  
  const errorClasses = error ? 'border-[#BB0000] focus-visible:ring-[#BB0000]' : '';
  
  const classes = cn(
    baseClasses,
    errorClasses,
    className
  );

  const handleChange = (e) => {
    if (onChange && e && e.target) {
      onChange(e);
    }
  };

  return (
    <div className="w-full">
      <input
        type={type}
        className={classes}
        ref={ref}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        required={required}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-[#BB0000] dark:text-[#BB0000]">
          {error}
        </p>
      )}
    </div>
  );
});

Input.displayName = 'Input';

const Textarea = React.forwardRef(({
  className,
  placeholder,
  value,
  onChange,
  error,
  disabled = false,
  required = false,
  rows = 3,
  ...props
}, ref) => {
  const baseClasses = 'flex min-h-[80px] w-full rounded-xl border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm';
  
  const errorClasses = error ? 'border-[#BB0000] focus-visible:ring-[#BB0000]' : '';
  
  const classes = cn(
    baseClasses,
    errorClasses,
    className
  );

  const handleChange = (e) => {
    if (onChange && e && e.target) {
      onChange(e);
    }
  };

  return (
    <div className="w-full">
      <textarea
        className={classes}
        ref={ref}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        required={required}
        rows={rows}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-[#BB0000] dark:text-[#BB0000]">
          {error}
        </p>
      )}
    </div>
  );
});

Textarea.displayName = 'Textarea';

export { Input, Textarea };